import { h } from '../utils'
import { fieldError } from './error'
import { uniqueId } from './id'
import { fieldLabel } from './label'

interface TextareaFieldOptions {
  label: string
  name: string
  rows?: number
  placeholder?: string
  required?: boolean
}

export function textareaField(options: TextareaFieldOptions) {
  const id = uniqueId()
  const control = h('div', { class: 'vbzc-control' })

  // Textarea
  const textarea = h(
    'textarea',
    {
      class: 'vbzc-input vbzc-textarea',
      id,
      name: options.name,
      placeholder: options.placeholder ?? '',
      rows: String(options.rows ?? 5),
    },
    { parent: control },
  )

  // Error
  const { el: error } = fieldError()

  // Field
  const field = h(
    'div',
    { 'class': 'vbzc-field', 'data-name': options.name },
    { children: [fieldLabel({ text: options.label, id, required: options.required }), control, error] },
  ) as HTMLDivElement

  return { field, textarea, error }
}
